import React, { useEffect, useState } from 'react';

const translations = {
  en: {
    title: "Privacy GDPR Statement",
    welcome: "Welcome to our HR assessment tool. Please note that we temporarily store your email address, CV, motivation letter, LinkedIn profile and questionnaire responses solely for testing and development purposes.",
    consent: "By clicking \"Accept,\" you consent to this data being retained to help us improve the application; otherwise, you will not be able to proceed. For more information please visit:",
    privacyLink: "Privacy GDPR Statement",
    accept: "Accept"
  },
  nl: {
    title: "Privacy GDPR Verklaring",
    welcome: "Welkom bij ons HR-assessment instrument. Houd er rekening mee dat we uw e-mailadres, CV, motivatiebrief, LinkedIn-profiel en vragenlijstantwoorden tijdelijk opslaan, uitsluitend voor test- en ontwikkelingsdoeleinden.",
    consent: "Door op \"Accepteren\" te klikken, stemt u in met het bewaren van deze gegevens om ons te helpen de applicatie te verbeteren; anders kunt u niet doorgaan. Voor meer informatie bezoek:",
    privacyLink: "Privacy GDPR Verklaring",
    accept: "Accepteren"
  }
};

const PrivacyPolicyPopup = ({ isOpen, onClose, isDutch }) => {
  const [currentTranslations, setCurrentTranslations] = useState(translations[isDutch ? 'nl' : 'en']);

  useEffect(() => {
    setCurrentTranslations(translations[isDutch ? 'nl' : 'en']);
  }, [isDutch]);

  if (!isOpen) return null;

  return (
    <div className="text-left fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-2xl mx-4">
        <h2 className="text-2xl font-bold mb-4 text-primary">{currentTranslations.title}</h2>
        <div className="space-y-4 text-gray-700">
          <p>
            {currentTranslations.welcome}
          </p>
          <p>
            {currentTranslations.consent} <a className='underline' href='https://ybinspire.com/privacy-gdpr-statement/' target='_blank'>{currentTranslations.privacyLink}</a>
          </p>
        </div>
        <button
          onClick={onClose}
          className="mt-6 px-6 py-2 bg-buttonColor w-full text-white rounded-lg transition-colors"
        >
          {currentTranslations.accept}
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicyPopup; 